export const LOCAL = "LOCAL";
export const LDAP = "LDAP";
// export const OPENID = 'OPENID';
